// Helpful? under the platform agent's finished answers and cards (D10). Wording from the Amigo design's copy sheet
// (Helpful?).
export default {
  question: 'Util?',
  helpful: 'Util',
  not_helpful: 'Neutil',
  thanks: 'Mulțumim, am notat.',
};
